var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 29.3337C23.3641 29.3337 29.3337 23.3641 29.3337 16.0003C29.3337 8.63653 23.3641 2.66699 16.0003 2.66699C8.63653 2.66699 2.66699 8.63653 2.66699 16.0003C2.66699 23.3641 8.63653 29.3337 16.0003 29.3337Z",
    fill: "#BF9A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 19.3333V12.6667L12.667 14.6667L16.0003 10L19.3337 14.6667L23.3337 12.6667V19.3333H8.66699Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrone);
export default __webpack_public_path__ + "static/media/crone.7d2210c7ca46057cc86ce4b71e6a72da.svg";
export { ForwardRef as ReactComponent };